// export const API_URL='https://pos.konicacomputers.com/api';
// export const API_URL='http://localhost:6052/api';
// export const API_URL='http://89.116.33.173:6052/api';
export const API_URL = 'https://pos.jnmhomoeosadan.com/api';